 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import EBOOK4242 from '@/components/eBook4242'
 import GROVEATLANTICLITHUB from '@/components/groveatlanticlithub'
 import LOVE_1 from '@/components/love_1'
 import EBOOK42421 from '@/components/eBook42421'
 import EBOOK42422 from '@/components/eBook42422'
 import EBOOK42423 from '@/components/eBook42423'
 import EBOOK42424 from '@/components/eBook42424'
 import EBOOK42425 from '@/components/eBook42425'
 import EBOOK42426 from '@/components/eBook42426'
 import EBOOK42427 from '@/components/eBook42427'
 import EBOOK42428 from '@/components/eBook42428'
 import EBOOK42429 from '@/components/eBook42429'
 import EBOOK424210 from '@/components/eBook424210'
 import EBOOK424211 from '@/components/eBook424211'
 import EBOOK424212 from '@/components/eBook424212'
 import EBOOK424213 from '@/components/eBook424213'
 import EBOOK424214 from '@/components/eBook424214'
 import EBOOK424215 from '@/components/eBook424215'
 import EBOOK424216 from '@/components/eBook424216'
 import EBOOK424217 from '@/components/eBook424217'
 import EBOOK424218 from '@/components/eBook424218'
 import EBOOK424219 from '@/components/eBook424219'
 import EBOOK424220 from '@/components/eBook424220'
 import EBOOK424221 from '@/components/eBook424221'
 import EBOOK424222 from '@/components/eBook424222'
 import EBOOK424223 from '@/components/eBook424223'
 import EBOOK424224 from '@/components/eBook424224'
 import EBOOK424225 from '@/components/eBook424225'
 import EBOOK424226 from '@/components/eBook424226'
 import EBOOK424227 from '@/components/eBook424227'
 import EBOOK424228 from '@/components/eBook424228'
 import EBOOK424229 from '@/components/eBook424229'
 import EBOOK424230 from '@/components/eBook424230'
 import EBOOK424231 from '@/components/eBook424231'
 import EBOOK424232 from '@/components/eBook424232'
 import EBOOK424233 from '@/components/eBook424233'
 import EBOOK424234 from '@/components/eBook424234'
 import EBOOK424235 from '@/components/eBook424235'
 import EBOOK424236 from '@/components/eBook424236'
 import EBOOK424237 from '@/components/eBook424237'
 import EBOOK424238 from '@/components/eBook424238'
 import EBOOK424239 from '@/components/eBook424239'
 import EBOOK424240 from '@/components/eBook424240'
 import EBOOK424241 from '@/components/eBook424241'
 import EBOOK424242 from '@/components/eBook424242'
 import EBOOK424243 from '@/components/eBook424243'
 import EBOOK424244 from '@/components/eBook424244'
 import EBOOK424245 from '@/components/eBook424245'
 import EBOOK424246 from '@/components/eBook424246'
 import EBOOK424247 from '@/components/eBook424247'
 import EBOOK424248 from '@/components/eBook424248'
 import EBOOK424249 from '@/components/eBook424249'
 import EBOOK424250 from '@/components/eBook424250'
 import EBOOK424251 from '@/components/eBook424251'
 import EBOOK424252 from '@/components/eBook424252'
 import EBOOK424253 from '@/components/eBook424253'
 import EBOOK424254 from '@/components/eBook424254'
 import EBOOK424255 from '@/components/eBook424255'
 import EBOOK424256 from '@/components/eBook424256'
 import EBOOK424257 from '@/components/eBook424257'
 import EBOOK424258 from '@/components/eBook424258'
 import EBOOK424259 from '@/components/eBook424259'
 import EBOOK424260 from '@/components/eBook424260'
 import EBOOK424261 from '@/components/eBook424261'
 import EBOOK424262 from '@/components/eBook424262'
 import EBOOK424263 from '@/components/eBook424263'
 import EBOOK424264 from '@/components/eBook424264'
 import EBOOK424265 from '@/components/eBook424265'
 import EBOOK424266 from '@/components/eBook424266'
 import EBOOK424267 from '@/components/eBook424267'
 import EBOOK424268 from '@/components/eBook424268'
 import EBOOK424269 from '@/components/eBook424269'
 import EBOOK424270 from '@/components/eBook424270'
 import EBOOK424271 from '@/components/eBook424271'
 import EBOOK424272 from '@/components/eBook424272'
 import EBOOK424273 from '@/components/eBook424273'
 import EBOOK424274 from '@/components/eBook424274'
 import EBOOK424275 from '@/components/eBook424275'
 import EBOOK424276 from '@/components/eBook424276'
 import EBOOK424277 from '@/components/eBook424277'
 import EBOOK424278 from '@/components/eBook424278'
 import EBOOK424279 from '@/components/eBook424279'
 import EBOOK424280 from '@/components/eBook424280'
 import EBOOK424281 from '@/components/eBook424281'
 import EBOOK424282 from '@/components/eBook424282'
 import EBOOK424283 from '@/components/eBook424283'
 import EBOOK424284 from '@/components/eBook424284'
 import EBOOK424285 from '@/components/eBook424285'
 import LOVE_2 from '@/components/love_2'
 import EBOOK424286 from '@/components/eBook424286'
 import EBOOK424287 from '@/components/eBook424287'
 import EBOOK424288 from '@/components/eBook424288'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/eBook4242",
 			"name" : "eBook4242",
 			"component" : EBOOK4242
 		},
 		{
 			"path" : "/groveatlanticlithub",
 			"name" : "groveatlanticlithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/eBook42421",
 			"name" : "eBook42421",
 			"component" : EBOOK42421
 		},
 		{
 			"path" : "/eBook42422",
 			"name" : "eBook42422",
 			"component" : EBOOK42422
 		},
 		{
 			"path" : "/eBook42423",
 			"name" : "eBook42423",
 			"component" : EBOOK42423
 		},
 		{
 			"path" : "/eBook42424",
 			"name" : "eBook42424",
 			"component" : EBOOK42424
 		},
 		{
 			"path" : "/eBook42425",
 			"name" : "eBook42425",
 			"component" : EBOOK42425
 		},
 		{
 			"path" : "/eBook42426",
 			"name" : "eBook42426",
 			"component" : EBOOK42426
 		},
 		{
 			"path" : "/eBook42427",
 			"name" : "eBook42427",
 			"component" : EBOOK42427
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js